import { axios } from "../config/axios";
import { IIssuedOperatorApiKey, IOperatorApiKey } from "../interfaces/endpoints/IOperatorApiKey.types";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";

export const getOperatorApiKeys = async (): Promise<IAxiosResponse<IOperatorApiKey[]>> =>
  axios.get("v1/OperatorApiKey");

export const issueOperatorApiKey = async (body: {
  userAccountId: number;
  name: string;
}): Promise<IAxiosResponse<IIssuedOperatorApiKey>> => axios.post("v1/OperatorApiKey", body);

export const revokeOperatorApiKey = async (id: number): Promise<IAxiosResponse<IOperatorApiKey>> =>
  axios.post(`v1/OperatorApiKey/${id}/Revoke`);
